import React from 'react';
import { connect } from 'react-redux';
import { IElectronicJournalRecord } from '../../../common/interfaces/states/IElectronicJournalRecord';
import { useTranslation } from 'react-i18next';
import { AppState } from '../../../common/redux/configure-store';
import { CouponSummaryListView } from './coupon-summary-list-view';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import { CouponSummaryGroupView } from './coupon-summary-group-view';

const CouponsSummaryMenu: React.FC<ICouponsSummaryMenuState> = (
  props: ICouponsSummaryMenuState,
) => {
  const { t } = useTranslation();
  const { groupedCouponSummary } = getCurrentXLRConfig();
  return groupedCouponSummary ? (
    <CouponSummaryGroupView title={t('CouponSummary_Heading')} testIdPrefix='coupons' {...props} />
  ) : (
    <CouponSummaryListView title={t('CouponSummary_Heading')} testIdPrefix='coupons' {...props} />
  );
};

const mapStateToProps = (state: AppState): ICouponsSummaryMenuState => ({
  items: state.itemList.ejItems,
});

interface ICouponsSummaryMenuState {
  items: IElectronicJournalRecord[];
}

export default connect(mapStateToProps)(CouponsSummaryMenu);
